/**
 * 역할 미리보기 — 내 계정 그대로 두고 화면만 다른 역할처럼 보는 기능.
 *
 * 왜 이게 필요한가: 2026-07-29 기준 서버의 사용자 계정이 **전부 MASTER** 다.
 * (`GET /api/clients/:id/members` 로 8개 회사 전부 확인 — MANAGER·CLIENT·DELIVERY 계정이 하나도 없다)
 * 그래서 "다른 계정으로 로그인해서 화면 확인"이 애초에 불가능하다. 계정이 생길 때까지는
 * 이 미리보기로 권한 표가 화면에 어떻게 먹히는지 확인한다.
 *
 * ⚠️ 화면만 바뀐다. API 요청은 여전히 내 토큰(MASTER)으로 나가므로 **데이터는 다 내려온다.**
 *    "이 역할에게 뭐가 보이나"를 확인하는 용도지, 데이터 격리를 검증하는 용도가 아니다.
 */

const STORAGE_KEY = 'blbent.previewRole';

/** 권한 표의 역할 키 → 미리보기용 serviceType/adminRole */
export const PREVIEW_ROLE_MAP = {
  MASTER: { serviceType: 'MASTER', adminRole: '' },
  AE: { serviceType: 'MANAGER', adminRole: 'AE' },
  KOL: { serviceType: 'MANAGER', adminRole: 'KOL' },
  CLIENT: { serviceType: 'CLIENT', adminRole: '' },
  DELIVERY: { serviceType: 'DELIVERY_THAILAND', adminRole: '' },
  INFLUENCER: { serviceType: 'INFLUENCER', adminRole: '' },
};

export const getPreviewRole = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY) || '';
    return PREVIEW_ROLE_MAP[v] ? v : '';
  } catch {
    return '';
  }
};

export const setPreviewRole = (role) => {
  if (!PREVIEW_ROLE_MAP[role]) return;
  localStorage.setItem(STORAGE_KEY, role);
};

export const clearPreviewRole = () => {
  localStorage.removeItem(STORAGE_KEY);
};
